const opacities = [0.05, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

type OpacityColors = Record<string, string>;

const hexToRgb = (val: string) => {
  const hex = val.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r},${g},${b}`;
};

const colorFactory = (baseHex: string): OpacityColors =>
  opacities.reduce((acc: OpacityColors, opacity, i) => {
    acc[`a${i}`] = `rgba(${hexToRgb(baseHex)},${opacity})`;
    return acc;
  }, {});

const brandRedHEX = '#e6406f';
const baseBlueHEX = '#4e546b';
const lightBlueHEX = '#55a6ff';
const mobileBlueHEX = '#323645';
const whiteHEX = '#ffffff';
const blackHEX = '#000000';
const goldHEX = '#fcab53';
const redHEX = '#ff4c79';
const greenHEX = '#58e8e0';

// We don't need them in different opacities for now
export const background = '#ededed';
export const violet = {
  light: '#ab4f6d',
  medium: '#6b4b6a',
  dark: '#523951',
};
export const brandBlue = {
  light: '#414d75',
  medium: '#2c3f73',
  dark: '#0c1733',
};

export const brandRed = colorFactory(brandRedHEX);
export const baseBlue = colorFactory(baseBlueHEX);
export const lightBlue = colorFactory(lightBlueHEX);
export const mobileBlue = colorFactory(mobileBlueHEX);
export const white = colorFactory(whiteHEX);
export const black = colorFactory(blackHEX);
export const gold = colorFactory(goldHEX);
export const red = colorFactory(redHEX);
export const green = colorFactory(greenHEX);
